<template>
    <div class="modal-card">
    <section class="modal-card-body">
    
        <h2 class="title is-2">
            Get started
        </h2>
        <br>
        <figure class="image" ratio="5by4" responsive>
            <h4 class="title is-5">Get Started in 10 minutos</h4>
            <h4 class="subtitle is-5">Watch our product demo</h4>
            <p>Create your first AI solution in less than 10 minutes</p>
            <iframe src="https://player.vimeo.com/video/760025721?h=c1a05049f7" 
            width="600" 
            frameborder="0" allowfullscreen></iframe>
        </figure>
    </section>
    </div>
  </template>
  
  <script>
  
  
  export default {
    props: ["boardId"],
    data() {
      return {
        gettingInfo: false,
        form: {
          url: ""
        }
      };
    },
    methods: {
      
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .board-editor {
    padding: 16px;
  }
  </style>